import { render, staticRenderFns } from "./switch-toggle.vue?vue&type=template&id=3bec97e1&"
import script from "./switch-toggle.vue?vue&type=script&lang=js&"
export * from "./switch-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports